'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.actions = exports.types = undefined;

var _ActionCreatorHelper = require('./ActionCreatorHelper');

var _proptypes = require('proptypes');

var _proptypes2 = _interopRequireDefault(_proptypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _actions = [{
    type: 'ORGANIZATION_LOAD',
    propTypes: {
        organization: _proptypes2.default.object.isRequired
    }
}];

var types = exports.types = (0, _ActionCreatorHelper.createTypes)(_actions);
var actions = exports.actions = (0, _ActionCreatorHelper.createActions)(_actions);


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/restaurants-redux/dist/actions/OrganizationActions.js
// module id = 282
// module chunks = 0